/* eslint-disable */
import types from './types';
import { initialState } from 'redux/initialState';

const thousand = 1000;
const sixteen = 16;

const unreadCountIncrement = 1;
const start = 0;

const getUnreadMsgsCount = (state, message) =>
  !state.isChatWidgetOpen && message.type
    ? state.unreadMsgsCount + unreadCountIncrement
    : state.unreadMsgsCount;

const exists = (msgs, msg) => Boolean(msgs.filter((m) => m.id === msg.id).length);

const updateMessages = (state, message) => {
  if (message.messageText && message.sentVia !== 'AriDisabled') {
    if (!exists(state.messages, message)) {
      return [...state.messages, message];
    }
  }
  return state.messages;
};

// eslint-disable-next-line complexity
const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ANON_INIT_REQUEST:
      return {
        ...state,
        isAnonInitializing: true,
        isAnonymous: true,
      };
    case types.ANON_INIT_SUCCESS:
      return {
        ...state,
        isAnonInitializing: false,
        addForm: false,
      };
    case types.ADD_REQUEST:
      return {
        ...state,
        isAdding: true,
      };
    case types.ADD_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isAdding: false,
        isInChat: true,
        candidate: {
          ...state.candidate,
          id: payload.candidateId,
          firstName: payload.candidateFirstName,
          lastName: payload.candidateLastName,
          phone: payload.candidatePhoneNumber,
          customerId: payload.customerId,
          customerName: payload.customerName,
        },
      };
    }
    case types.ADD_FAILURE:
      return {
        ...state,
        isAdding: false,
        error: action.error,
      };

    case types.SET_FAKE_MESSAGE:
      return {
        ...state,
        initialAriMessageObj: {
          id: '61fad7992382d20377b8146c',
          messageText: action.additionalData.text,
          type: 1,
          status: 'sent',
          time: new Date().toISOString(),
          sentVia: 'Sequence',
          dataType: 'Text',
          sentAsUser: 'Sequence',
          userFirstName: 'Digital Assistant',
          candidateName: 'Candidate',
          userName: 'ari@example.com',
        },
      };
    // TODO: may not be needed any more
    case types.ADD_FAKE_MESSAGE: {
      // For consistency, fabricate MongoDB Object ID's first 4-bytes
      /* eslint no-magic-numbers: ["error", { "ignore": [1e3, 16] }]*/
      const hexId = Math.floor(Date.now() / thousand).toString(sixteen);
      const msgObj = {
        candidateId: new Date().toISOString(),
        type: action.additionalData.type,
        status: 'sent',
        messageText: action.additionalData.text,
        time: new Date().toISOString(),
        sentVia: action.additionalData.sentVia || 'Sequence',
        id: hexId,
        dataType: 'Text',
        sentAsUser: 'Sequence',
        userFirstName: 'Digital Assistant',
        candidateName: 'Candidate',
        userName: 'ari@example.com',
      };
      return {
        ...state,
        isLoadingMsgs: false,
        messages: [msgObj, ...state.messages],
      };
    }
    case types.SET_IS_ANON:
      return {
        ...state,
        isAnonymous: true,
      };
    case types.ENTER_CHAT:
      return {
        ...state,
        isInChat: true,
      };
    case 'UPLOAD_RESUME':
      return {
        ...state,
        resumeUploaded: true,
      };
    case types.GET_MESSAGES_SUCCESS: {
      const msgs = [];
      let sequenceId = null;
      action.payload.messages.forEach((m) => {
        if ((m.messageText || '').trim()) {
          msgs.push(m);
        }
        if (m.dataType === 'FileUploadRequest') {
          sequenceId = m.sequenceId;
        }
      });
      if (!state.isChatWidgetOpen) {
        state.unreadMsgsCount += 1;
      }
      return {
        ...state,
        messages: state.messages.slice(start, start).concat(msgs),
        isLoadingMsgs: false,
        unreadMsgsCount: state.unreadMsgsCount,
        sequenceId,
      };
    }
    case types.GET_MESSAGES_FAILURE:
      return {
        ...state,
        isLoadingMsgs: false,
      };
    case types.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        isSendingMsg: true,
      };
    case types.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: updateMessages(state, action.payload.message),
        isSendingMsg: false,
      };
    case types.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        isSendingMsg: false,
        sendError: action.payload,
      };
    case types.REAL_TIME_MSG: {
      const { message } = action.payload;

      if (message.messageText) {
        const isDuplicate = exists(state.messages, message);
        if (!isDuplicate) {
          return {
            ...state,
            messages: [...state.messages, message],
            unreadMsgsCount: getUnreadMsgsCount(state, message),
            sequenceId: message.dataType === 'FileUploadRequest' ? message.sequenceId : null,
          };
        }
      }
      return state;
    }
    case types.TOGGLE_WIDGET:
      return {
        ...state,
        isChatWidgetOpen: !state.isChatWidgetOpen,
        unreadMsgsCount: state.isChatWidgetOpen ? start : state.unreadMsgsCount,
      };
    case types.RESET_APP:
      return {
        ...initialState,
        isAnonymous: state.isAnonymous,
        initialAriMessageObj: state.initialAriMessageObj,
      };
    case types.SET_IS_CHAT_WIDGET_OPEN:
      return {
        ...state,
        isChatWidgetOpen: true,
      };
    case types.SET_SESSION:
      return {
        ...state,
        state: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
